import { type KorintModulesProductsConfig, useKorintProductConfigSuspense } from 'korint-sdk/react';
import { usePolicyOnDashboard } from './usePolicyOnDashboard';

export const useHasPolicyProductConfig = <TKey extends keyof KorintModulesProductsConfig>(
  key: TKey,
) => {
  const { policy } = usePolicyOnDashboard();

  const productsConfig = useKorintProductConfigSuspense();

  const productConfig = productsConfig[policy.productId];

  if (!productConfig) {
    throw new Error('Product config not found');
  }

  return Boolean(productConfig[key]);
};

export const usePolicyProductConfig = <TKey extends keyof KorintModulesProductsConfig>(
  key: TKey,
): NonNullable<KorintModulesProductsConfig[TKey]> => {
  const productsConfig = useKorintProductConfigSuspense();
  const { policy } = usePolicyOnDashboard();

  const productConfig = productsConfig[policy.productId];

  if (!productConfig) throw new Error('Product config not found');

  const productConfigItem = productConfig[key];
  if (productConfigItem === undefined || productConfigItem === null)
    throw new Error(`Product config item ${key} not found`);

  return productConfigItem;
};
